import configData from '@/src/config.json';

export const closeDropDown = () => {
  window.parent.postMessage({ message: configData.HOME.CLOSE_DROP_DOWN }, '*');
};
